import { Box, BoxProps } from '@chakra-ui/react'
import React, { forwardRef } from 'react'

interface Props extends BoxProps {
  children: React.ReactNode | React.ReactNode[]
}

export default function HoverBox({ children, ...restProps }: Props) {
  return (
    <Box
      padding="8px"
      _hover={{
        cursor: 'pointer',
        bgColor: 'blackAlpha.500',
      }}
      {...restProps}
    >
      {children}
    </Box>
  )
}
